"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockGeoCoderLake = exports.mockWaterbodyPin = exports.mockWaterbody = exports.mockWaterbodyDetail = void 0;
const __1 = require("..");
const season_1 = require("./season");
const state_1 = require("./state");
function mockWaterbodyDetail(overrides = {}) {
    const id = (0, __1.incrementingId)().toString();
    return {
        ambassadors_count: 0,
        activation_requested: false,
        area_sqkm: 100,
        average_depth_ft: 20,
        bbox: [
            [-93.1551670991779, 45.0731301967041],
            [-93.1551670991779, 45.0780667300298],
            [-93.1487938325211, 45.0780667300298],
            [-93.1487938325211, 45.0731301967041],
            [-93.1551670991779, 45.0731301967041],
        ],
        distance: null,
        favorites_count: 0,
        fishing_reports_count: 0,
        clarity: 5,
        classification: {
            name: 'Lake/Pond',
            description: 'Hydrographic Category|intermittent',
        },
        description: 'mock description',
        has_lunker_potential: false,
        has_summary: false,
        has_survey_chart_data: false,
        hot_scale: 0,
        hotbaits_count: 0,
        id,
        lat: 40,
        links: [],
        lng: -90,
        locales: [
            {
                state: (0, state_1.mockState)(),
                counties: ['Ramsey'],
            },
        ],
        media_count: 0,
        meta_description: 'mock meta_description',
        meta_title: 'mock meta_title',
        omnia_clarity: 5,
        page_heading: 'mock page heading',
        primary_name: 'lake primary name',
        season_groups: [(0, __1.mockSeasonGroup)()],
        season_zones: [],
        seasons: [(0, season_1.mockSeason)({ active: true })],
        secondary_title: 'mock secondary_title',
        send_off_message: 'mock send_off_message',
        send_off_title: 'mock send_off_title',
        seo_indexed: false,
        species_known: true,
        species: [],
        top_species: null,
        user_preferences: {
            clarity: null,
            favorite: false,
        },
        user_event_notifications: {
            new_fishing_report: false,
            new_article: false,
            frequency: 'weekly',
        },
        url_slug: 'lake-primary-name',
        water_temperature_recorded_at: '2024-08-21',
        water_temperature: 73,
        waterbody_id: id,
        ...overrides,
    };
}
exports.mockWaterbodyDetail = mockWaterbodyDetail;
function mockWaterbody(overrides = {}) {
    const id = (0, __1.incrementingId)().toString();
    return {
        ambassadors_count: 0,
        area_sqkm: 26.4,
        bbox: [
            [-93.0814968992922, 45.1567917299076],
            [-93.0814968992922, 45.1697263298875],
            [-93.0582994993283, 45.1697263298875],
            [-93.0582994993283, 45.1567917299076],
            [-93.0814968992922, 45.1567917299076],
        ],
        distance: null,
        favorites_count: 0,
        fishing_reports_count: 0,
        has_summary: false,
        hot_scale: 0,
        hotbaits_count: 0,
        id,
        lat: 40,
        lng: -90,
        locales: [
            {
                state: (0, state_1.mockState)(),
                counties: ['Ramsey'],
            },
        ],
        media_count: 0,
        omnia_clarity: 5,
        primary_name: 'lake primary name',
        url_slug: 'lake-primary-name',
        water_temperature_recorded_at: '2024-08-21',
        water_temperature: 73,
        waterbody_id: id,
        ...overrides,
    };
}
exports.mockWaterbody = mockWaterbody;
function mockWaterbodyPin(overrides = {}) {
    return {
        ...mockWaterbody(overrides),
        has_lunker_potential: false,
        has_survey_chart_data: false,
        locales: [],
    };
}
exports.mockWaterbodyPin = mockWaterbodyPin;
function mockGeoCoderLake(overrides = {}) {
    return {
        place_name: 'lake primary name, county MN',
        url_slug: 'lake-primary-name',
        id: (0, __1.incrementingId)().toString(),
        ...overrides,
    };
}
exports.mockGeoCoderLake = mockGeoCoderLake;
